<div class="btn-container">
  <div class="btn-group">
    <ng-content></ng-content>
  </div>
</div>
